export const UPDATE_INITIAL_DATA = 'UPDATE_INITIAL_DATA';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';

export const REGISTER_USER_DATA_SUCCESS = 'REGISTER_USER_DATA_SUCCESS';
export const REGISTER_USER_DATA_ERROR = 'REGISTER_USER_DATA_ERROR';

export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'VERIFY_OTP_ERROR';

export const UPADTE_PAN_INFO_SUCCESS = 'UPADTE_PAN_INFO_SUCCESS';
export const UPADTE_PAN_INFO_ERROR = 'UPADTE_PAN_INFO_ERROR';
export const RESET_PAN_INFO = 'RESET_PAN_INFO';

export const UPDATE_MODAL_KYC = 'UPDATE_MODAL_KYC';

export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FAIL';

export const UPLOAD_KYC_SUCCESS = 'UPLOAD_KYC_SUCCESS';
export const UPLOAD_KYC_ERROR = 'UPLOAD_KYC_ERROR';

export const UPLOAD_FACADE_SUCCESS = 'UPLOAD_FACADE_SUCCESS';
export const UPLOAD_FACADE_ERROR = 'UPLOAD_FACADE_ERROR';

export const PREREGISTER_USER = 'PREREGISTER_USER';
export const PREREGISTER_SUCCESS = 'PREREGISTER_SUCCESS';
export const PREREGISTER_FAIL = 'PREREGISTER_FAIL';

export const SET_USER_CREDENTIALS = 'SET_USER_CREDENTIALS';
export const SET_USER_CREDENTIALS_ERROR = 'SET_USER_CREDENTIALS_ERROR';

export const LOADING_FOR_NEXT = 'LOADING_FOR_NEXT';
export const LOADING_FOR_KYCINFO = 'LOADING_FOR_KYCINFO';

export const RESEND_COUNT = 'RESEND_COUNT';

export const UPDATE_NAME_ISSUE = 'UPDATE_NAME_ISSUE';

export const UPDATE_PREV_PAGE_NAME = 'UPDATE_PREV_PAGE_NAME';

export const RESET_INITIAL_DATA = 'RESET_INITIAL_DATA';

// New onboarding flow
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_ERROR = 'SEND_OTP_ERROR';
export const DISABLED_BUTTON = 'DISABLED_BUTTON';
export const VERIFY_MOBILE_OTP_SUCCESS = 'VERIFY_MOBILE_OTP_SUCCESS';
export const VERIFY_MOBILE_OTP_ERROR = 'VERIFY_MOBILE_OTP_ERROR';
export const KYCDOC_SUCCESS = 'KYCDOC_SUCCESS';
export const LOADER_LOGIN_HOME = 'LOADER_LOGIN_HOME';
export const GET_AGREEMENT = 'GET_AGREEMENT';
export const CHANGE_USER_COUNTRY = 'CHANGE_USER_COUNTRY';
export const UPADTE_PASSPORT_INFO_ERROR = 'UPADTE_PASSPORT_INFO_ERROR';
export const UPDATE_LOB = 'UPDATE_LOB';
export const UPDATE_FORMFIELD_DATA_LOGIN = 'UPDATE_FORMFIELD_DATA_LOGIN';
